import React, { PureComponent } from 'react';

import CalendarBase from './calendar-base/CalendarBase';
import * as CalendarState from '../../state/reducer/calendar/calendar';

import Console from '../../lib/debug';

export default class InvitedAthleteCalendarView extends PureComponent {
    constructor(props) {
        super(props);
        this.loadInvitedAthleteCalendarData(props);
    }

    componentWillUpdate(nextProps) {
        this.loadInvitedAthleteCalendarData(nextProps);
    }

    loadInvitedAthleteCalendarData(props) {
        const inviteId = parseInt(props.match.params.inviteId, 10);
        const year = parseInt(props.match.params.year, 10);
        const month = parseInt(props.match.params.month, 10);
        CalendarState.loadInvitedAthleteCalendar(inviteId, year, month);
    }

    render() {
        Console.render('InvitedAthleteCalendarView');
        return <CalendarBase />;
    }
}
